import React, {useState} from 'react';
import PropTypes from 'prop-types';

const AlertBanner = ({message}) => {
    const [viewed, setViewed] = useState(false);

    return (
        <div className={`alert-box ${viewed ? 'viewed' : ''}`}>
            <div className="alert-message">{message}</div>
            <button className="close-icon" onClick={() => setViewed(true)}>
                X
            </button>
        </div>
    );
};

AlertBanner.propTypes = {
    message: PropTypes.string
};

export default AlertBanner;
